module.exports = fox._r("images/logo-def.png", __webpack_public_path__ + "images/logo-def.png");


//////////////////
// WEBPACK FOOTER
// ./images/logo-def.png
// module id = 155
// module chunks = 5